// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SorterSmallDoubleIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="SorterSmallDoubleIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M7.868 3.678 4.596 6.94l.847.854L7.19 6.061v4.458h1.35V6.056l1.753 1.738.838-.85z" />
      <path d="m15.404 13.06-3.271 3.262-3.264-3.266.839-.85 1.752 1.738V9.5h1.35v4.44l1.747-1.734z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const SorterSmallDoubleIcon = /* @__PURE__ */ Object.assign(
  SorterSmallDoubleIconComponent,
  { displayName: 'SorterSmallDoubleIcon' },
);
